import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AccountService } from '@app/account/account.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { WithdrawalProductDTO } from '@generated/generatedEntities';

@UntilDestroy()
@Component({
  selector: 'app-billing-free',
  templateUrl: './billing-free.component.html',
  styleUrls: ['./billing-free.component.scss'],
})
export class BillingFreeComponent implements OnInit {
  @Input() activeWp!: WithdrawalProductDTO;
  @Output() licenceChanged = new EventEmitter<void>();

  constructor(private accountService: AccountService) {}

  ngOnInit(): void {
    this.accountService
      .getActiveWp()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (activeWp) => {
          //console.log('activeWp',activeWp);
          if (activeWp != null) {
            this.activeWp = activeWp;
          }
        },
      });
  }
}
